import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { useTranslation } from "react-i18next";

export const KeyContactIcon: React.FC<SvgIconProps> = (props) => {
  const { t: translateUi } = useTranslation("ui");

  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="10" />
      <path
        aria-label={translateUi("icons.key_contact")}
        // eslint-disable-next-line max-len
        d="M12 16.0492L16.12 18.6667L15.0266 13.7334L18.6666 10.4141L13.8733 9.98601L12 5.33337L10.1266 9.98601L5.33331 10.4141L8.97331 13.7334L7.87998 18.6667L12 16.0492Z"
        fill="white"
      />
    </SvgIcon>
  );
};
